import { dropWhile, takeWhile } from '@dhl/utils'

import { Step } from '~/basket/model/reducers'

/**
 * Given a displayedStepName (the page to be displayed) the `getBasketNavigation` function returns a
 * `BasketNavigation` object which could be used to:
 *
 * 1. Decide if the step is allowed to be shown
 *      - Usefull for redirecting
 *
 * 2. The previous and next step
 *      - Usefull for the main navigation
 *
 * 3. The previous and next steps (plural)
 *      - Usefull for the stepper
 *
 * The `withBasket` HOC uses this function to inject the `BasketNavigation` into each page in the shipment funnel
 */

export type BasketNavigation = {
  isDisplayedStepAllowed: boolean
  previousSteps: Step[]
  previousStep: Step | null
  displayedStep: Step
  nextStep: Step | null
  nextSteps: Step[]
}

export const getBasketNavigation =
  (steps: Step[]) =>
  (displayedStepName: string): BasketNavigation => {
    const previousSteps = takeWhile(steps, (step) => step.name !== displayedStepName)
    const [displayedStep, ...nextSteps] = dropWhile(steps, (step) => step.name !== displayedStepName)

    const { [previousSteps.length - 1]: previousStep } = previousSteps
    const { 0: nextStep } = nextSteps
    const isDisplayedStepAllowed = previousSteps.every((step) => step.isDone)

    return {
      previousSteps,
      previousStep: previousStep || null,
      displayedStep,
      nextStep: nextStep || null,
      nextSteps,
      isDisplayedStepAllowed,
    }
  }
